module.exports = __webpack_public_path__ + "static/media/notification-red.fade6076.svg";